module.exports = __webpack_public_path__ + "media/images/frontend/pages/home-4-f68475160ee35ae0bb0de297b1ebfac1.jpg";